/**
 * Deep links from GID into the Service4Charger Dynamics (Dataverse) org.
 *
 * Dynamics addresses records by GUID, never by order number, so the job payload
 * carries `s4c_salesorder_id` — the Dataverse `salesorderid` that gid-api
 * resolves from `job.s4c_order_id` through the `s4c_sales_order` mirror table.
 */

// Same value as POWERPLATFORM_S4C_URL in gid-deployment. Hardcoded because the
// admin app has no runtime config channel (its env is baked at build time) and
// the org URL is stable; if S4C ever moves org, this is the single place to
// change.
const S4C_DYNAMICS_BASE = 'https://service4charger.crm4.dynamics.com';

/**
 * URL for an S4C salesorder. Prefers the exact record; falls back to a Dynamics
 * relevance search on the order number when the mirror row has not synced yet
 * (~0.2% of jobs), so the chip always leads somewhere useful rather than
 * silently doing nothing.
 *
 * Returns null when there is nothing to link to, so callers can guard on it.
 */
export function s4cSalesOrderUrl(salesOrderId, orderNumber) {
  if (salesOrderId) {
    return `${S4C_DYNAMICS_BASE}/main.aspx?pagetype=entityrecord&etn=salesorder&id=${encodeURIComponent(
      salesOrderId,
    )}`;
  }
  if (orderNumber) {
    return `${S4C_DYNAMICS_BASE}/main.aspx?pagetype=search&searchText=${encodeURIComponent(
      orderNumber,
    )}`;
  }
  return null;
}

/**
 * Open a job's S4C salesorder in a new tab. `item` is a job-view row, which
 * carries the order number under `job` and the resolved GUID at the top level.
 */
export function openS4cSalesOrder(item) {
  const url = s4cSalesOrderUrl(
    item?.s4c_salesorder_id,
    item?.job?.s4c_order_id,
  );
  if (!url) {
    return;
  }
  window.open(url, '_blank', 'noopener');
}
